'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ThreatRegisterPage } from '@/features/threats/components/ThreatRegisterPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/threats/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.threatRegister', { defaultValue: 'Threat register' }),
  }),
  component: ThreatsPage,
});

function ThreatsPage() {
  return <ThreatRegisterPage />;
}
